import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Button } from "@/components/ui/button";

export default function FAQ() {
  const [faqs, setFaqs] = useState([]);
  useEffect(() => { api.get("/faqs").then((r) => setFaqs(r.data.faqs)); }, []);

  return (
    <div className="mx-auto max-w-3xl px-5 py-16 lg:px-8">
      <div className="text-center">
        <span className="overline">FAQ</span>
        <h1 className="mt-2 text-4xl lg:text-5xl">Questions, answered</h1>
        <p className="mt-3 text-taupe">Everything you need to know about booking and hosting with Elite STR.</p>
      </div>

      <Accordion type="single" collapsible className="mt-10">
        {faqs.map((f, i) => (
          <AccordionItem key={i} value={`item-${i}`} data-testid={`faq-${i}`} className="border-b border-black/5">
            <AccordionTrigger className="py-5 text-left text-lg font-medium text-ink hover:text-camel hover:no-underline">{f.q}</AccordionTrigger>
            <AccordionContent className="pb-5 text-base text-taupe">{f.a}</AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>

      <div className="mt-12 rounded-3xl bg-cream p-8 text-center">
        <h2 className="text-2xl">Still have questions?</h2>
        <p className="mt-2 text-taupe">Our team is a message away.</p>
        <Link to="/contact"><Button className="mt-5 rounded-full btn-ink px-6">Contact us</Button></Link>
      </div>
    </div>
  );
}
